/*                                  */
/**
 *
 */
export const logoMap = {
  "pl_logo_app-store": {
    width: 7.5,
    height: 2.5
  },
  "pl_logo_ehi": {
    width: 2.5,
    height: 2.5
  },
  "pl_logo_facebook": {
    width: 1.5,
    height: 1.5
  },
  "pl_logo_github": {
    width: 1.5,
    height: 1.5
  },
  "pl_logo_instagram": {
    width: 1.5,
    height: 1.5
  },
  "pl_logo_linkedin": {
    width: 1.5,
    height: 1.5
  },
  "pl_logo_mastercard": {
    width: 4.0625,
    height: 2.5
  },
  "pl_logo_otto-app": {
    width: 2.5,
    height: 2.5
  },
  "pl_logo_otto-deprecated": {
    width: 8.75,
    height: 3.25
  },
  "pl_logo_otto-payments": {
    width: 20.1875,
    height: 2.5
  },
  "pl_logo_otto-up-claim-white": {
    width: 9.875,
    height: 3.5625
  },
  "pl_logo_otto-up-claim": {
    width: 9.875,
    height: 3.5625
  },
  "pl_logo_otto-up-white": {
    width: 9.875,
    height: 2.5
  },
  "pl_logo_otto-up": {
    width: 9.875,
    height: 2.5
  },
  "pl_logo_otto-white": {
    width: 7.4375,
    height: 2.5
  },
  "pl_logo_otto": {
    width: 7.4375,
    height: 2.5
  },
  "pl_logo_paypal-monogram": {
    width: 2.125,
    height: 2.5
  },
  "pl_logo_paypal": {
    width: 7.5,
    height: 2.5
  },
  "pl_logo_pinterest": {
    width: 1.5,
    height: 1.5
  },
  "pl_logo_play-store": {
    width: 8.4375,
    height: 2.5
  },
  "pl_logo_sepa-horizontal": {
    width: 6.125,
    height: 2.5
  },
  "pl_logo_sepa-vertical": {
    width: 1.9375,
    height: 2.5
  },
  "pl_logo_slogan": {
    width: 9.9375,
    height: 2.5
  },
  "pl_logo_snapchat": {
    width: 1.5,
    height: 1.5
  },
  "pl_logo_tiktok": {
    width: 1.5,
    height: 1.5
  },
  "pl_logo_up-white": {
    width: 4.1875,
    height: 2.5
  },
  "pl_logo_up": {
    width: 4.1875,
    height: 2.5
  },
  "pl_logo_visa": {
    width: 7.75,
    height: 2.5
  },
  "pl_logo_xing": {
    width: 1.5,
    height: 1.5
  },
  "pl_logo_youtube": {
    width: 1.5,
    height: 1.5
  }
} as const;
